var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-rounded-3 tw-shadow-app",on:{"click":_vm.clicked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }